import { IsDateString, IsEnum, IsNotEmpty, IsOptional } from 'class-validator';

export enum DashboardTopProductsBy {
  revenue = 'revenue',
  orders = 'orders'
}

export enum DashboardOrderType {
  all = '_ALL',
  oneTime = 'one_time',
  subscription = 'subscription'
}

export enum DashboardProductType {
  all = '_ALL',
  physical = 'physical',
  digital = 'digital'
}

export class DashboardDateRangeQueryDto {
  @IsNotEmpty()
  @IsDateString()
  datefrom: string;

  @IsNotEmpty()
  @IsDateString()
  dateto: string;

  @IsOptional()
  @IsEnum(DashboardTopProductsBy)
  by?: DashboardTopProductsBy;

  @IsOptional()
  @IsEnum(DashboardOrderType)
  orderType?: DashboardOrderType;

  @IsOptional()
  @IsEnum(DashboardProductType)
  productType?: DashboardProductType;

  @IsOptional()
  categoryId?: string;

  @IsOptional()
  productId?: string;
}

